<template>
    <div class="order-confirm-mobile-container">

        <div class="order-qualify-alert" v-if="!isQualify">
            <el-alert
                type="warning"
                :closable="false"
                show-icon
            >
                温馨提示：开通工商财税CBS服务需首先要完成实名认证/企业认证，您还没有认证，
                <a
                    class="text-link"
                    target="_blank"
                    href="https://console.bce.baidu.com/qualify/#/qualify/index"
                >去认证></a>
            </el-alert>
        </div>

        <el-dialog
            top="42vh"
            width="40%"
            :modal="false"
            :visible.sync="dialogVisible"
            custom-class="qualify-alert-dialog"
        >
            请先完成实名认证
        </el-dialog>

        <div v-if="orderItemObj" id="mobile-order-confirm"></div>

        <div class="order-footer">
            <div class="order-agreement">
                <span
                    :class="{'order-radius': true, 'agreed': protocolChecked}"
                    @click="protocolChecked = !protocolChecked"
                ></span>
                <span class="order-agreement-label">同意并接受</span>
                <a :href="protocol.href">
                    {{ protocol.name }}
                </a>
            </div>

            <div class="fixed-part">
                <button class="btn-easy" @click="goBackStep">上一步</button>
                <button
                    :class="{'btn-deep': true, disable: !protocolChecked}"
                    @click="onConfirmOrder"
                    :disabled="!protocolChecked"
                >确认订单</button>
            </div>
        </div>
    </div>
</template>

<script>
import {MobileOrderConfirm, MobileOrderPay} from '@baidu/bce-billing-sdk-mobile';
import {OrderItem, BillingSdk} from '@baidu/bce-billing-sdk';
import {getCookie, addMobileHeader, initAxios, resetRem} from '../../util/helper';
import Link from '../../util/link';
import {Loading, Notification} from 'element-ui';
import client from '../../common/client';
import {getIamRoleCheck} from '../../util/iam';

export default {
    props: {
        backUrl: {
            type: String,
            default: '#/bkp/detail'
        },
        orderFrom: {
            type: String,
            default: 'aiqicha'
        },
        protocol: {
            type: Object,
            default: () => {
                return {
                    name: '《百度智能云线上订购协议》',
                    href: 'https://console.bce.baidu.com/iam/agreement-v2.html'
                };
            }
        },
        orderItemObj: {
            type: Object,
            default: () => {
                return {};
            }
        },
        submitOrderItem: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },

    data() {
        return {
            loading: null,
            protocolChecked: true,
            orderItems: null,
            // 判断用户是否实名
            isQualify: true,
            // 提交订单前开启实名认证弹窗
            dialogVisible: false
        };
    },

    created() {
        resetRem();
        addMobileHeader();
        this.openLoading();
        this.checkUserQualify();
        this.initPage();
    },

    watch: {
        orderItemObj() {
            this.initPage();
        }
    },

    methods: {
        /**
         * 判断用户是否实名
         */
        async checkUserQualify() {
            const {data}  = await client.checkUserQualify();
            this.isQualify = data?.result;
        },
        /**
         * 封装 http
         */
        getHttp() {
            const axiosConfig = {
                baseURL: Link.host,
                withCredentials: true
            };
            // 初始化axios请求实例
            return initAxios(axiosConfig);
        },
        /**
         * 初始化确认订单页
         */
        initPage() {
            if (!this.orderItemObj) {
                return;
            }

            const sdk = new BillingSdk({
                client: this.getHttp()
            });

            const orderItem = new OrderItem(this.orderItemObj);
            this.orderItems = orderItem;
            sdk.addItems([orderItem]);

            const instance = new MobileOrderConfirm({sdk});
            instance.init(); // 初始化订单确认页
            setTimeout(() => {
                this.loading && this.loading.close();
            }, 800);

            // 在IAM开通CBS产品
            getIamRoleCheck();
        },
        /**
         * 返回上一页
         */
        goBackStep() {
            window.location.href = this.backUrl;
        },
        /**
         * 提交订单
         */
        async onConfirmOrder() {
            // 提交订单前，进行实名认证提醒
            if (!this.isQualify) {
                this.dialogVisible = true;
                return;
            }

            const params = {};
            params.orderItems = [this.submitOrderItem];

            let cbsCouponId = this.orderItems.couponId;
            if (cbsCouponId) {
                params.couponId = cbsCouponId;
            }

            const headers = {
                'X-Requested-With': 'XMLHttpRequest',
                csrfToken: getCookie('bce-user-info') // 获取cookie中的bce-user-info
            };
            const {data} = await client.submitOrder(params, {headers});
            if (data.orderId && data.serviceType) {
                this.orderPay(data.orderId);
            }
            else if (data?.message?.global) {
                Notification.error({
                    title: '订单提交失败',
                    message: data.message.global,
                    offset: 60,
                    duration: 2000
                });
            }
        },
        /**
         * 支付订单
         */
        orderPay(orderId) {
            const params = '?orderFrom=' + this.orderFrom;
            const pay = new MobileOrderPay({
                orderId, // 传入订单ID，如果有多个订单需要批量支付，则每个订单Id以逗号连接
                http: this.getHttp(), // axios的请求实例
                successUrl: Link.successUrl + params // 支付成功后返回的页面
            });
            pay.init(); // 初始化支付弹窗
        },
        /**
         * 加载中
         */
        openLoading() {
            this.loading = Loading.service({
                lock: true,
                text: '订单信息加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
            });
        }
    }
};
</script>

<style lang="less" scoped>
.order-confirm-mobile-container {
    background-color: #F5F5F5;
    min-height: 100vh;
    padding-top: 15px;
    padding-bottom: 16.2rem;

    .order-qualify-alert {
        margin-bottom: 15px;
        .el-alert {
            border: 1px solid;
        }
        .text-link {
            color: #2468f2;
        }
    }

    .order-footer {
        width: 100%;
        position: fixed;
        left: 0;
        bottom: 0;
        padding: 0 3.4rem;
        background-color: #FFF;
        border-top: 0.1rem solid #DCDFE6;
    }

    .order-agreement {
        margin-top: 9px;
        .order-agreement-label {
            font-size: 14px;
            vertical-align: middle;
            margin-left: 2rem;
        }
        a {
            font-size: 14px;
            color: #2A62FE;
            text-decoration: none;
            vertical-align: middle;
        }
    }

    .order-radius {
        display: inline-block;
        width: 2.6rem;
        height: 2.6rem;
        opacity: 0.3;
        border: 0.1rem solid #1B1E3F;
        border-radius: 50%;
        margin-right: .25rem;
        vertical-align: middle;
    }

    .order-radius.agreed {
        background-image: url(../../assets/mobile/cbs/gou2.png);
        background-size: 100% 100%;
        opacity: 1;
        border: none;
    }

    .fixed-part {
        height: 9.8rem;
        max-height: 49px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        button {
            width: 32.6rem;
            height: 8rem;
            max-height: 40px;
            font-family: PingFangSC-Regular;
            font-size: 2.8rem;
            letter-spacing: 0;
            text-align: center;
            font-weight: 400;
            border-radius: 4px;
            border: none;
        }
        .btn-deep {
            color: #FFF;
            background: #2A62FE;
            &.disable {
                background-color: #DCDFE6;
                border-color: #DCDFE6;
                color: #FFF;
                cursor: not-allowed;
            }
        }
        .btn-easy {
            color: #2A62FE;
            background: #FFF;
            border: 0.2rem solid #2A62FE;
        }
    }
}

/deep/.qualify-alert-dialog {
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 8px 16px;
        border-radius: 4px;
        text-align: center;
        font-size: 14px;
        background: #000;
        color: #FFF;
        .text-link {
            color: #FFF;
        }
    }
}
</style>